























































































































import { Component, Ref } from 'vue-property-decorator'
import { register, checkCaptcha } from '@/request/apis/UserRequest'
import { ElForm } from 'element-ui/types/form'
import CaptchaInput from '@/components/common/CaptchaInput.vue'
import RouterHelper from '@/mixins/RouterHelper.vue'
import IndustrySelector from '@/components/register_login/IndustrySelector.vue'
import CountrySelector from '@/components/register_login/CountrySelector.vue'

@Component({
  components: {
    CaptchaInput,
    IndustrySelector,
    CountrySelector,
  }
})
export default class MailRegisterForm extends RouterHelper {
    @Ref('form') readonly submitForm!: ElForm
    @Ref('captchaInput') readonly captchaInput!: CaptchaInput

    private form: any = {
      username: '',
      email: '',
      password: '',
      password2: '',
      captcha: '',
      industry: '',
      industryInput: '',
      organization: '',
      region: 'China',
      career: ''
    }
    private loading: boolean = false
    private readDisclaimer: boolean = true

    // 是否选择了其他行业
    get selectOtherIndustry () {
      return this.form.industry === 'Other'
    }

    private get rules () {
      const checkCaptcha = (rule: any, value: string, callback: Function) => {
        if (!value) {
          return callback(new Error(<string>this.$t('loginRegister.captchaEmptyError')))
        }
        if (!this.captchaInput.captchaIsCorrect) {
          return callback(new Error(<string>this.$t('loginRegister.captchaNotCorrect')))
        }
        callback()
      }
      const checkConfirmPassword = (rule: any, value: string, callback: Function) => {
        if (!(this.form.password === this.form.password2)) {
          return callback(new Error(<string>this.$t('loginRegister.passwordNotMatch')))
        }
        callback()
      }
      const checkIndustry = (rule: any, value: string, callback: Function) => {
        if (!value || (this.selectOtherIndustry && !this.form.industryInput)) {
          return callback(new Error(<string>this.$t('loginRegister.register.industryEmptyError')))
        }
        callback()
      }
      const checkEmail = (rule: any, value: string, callback: Function) => {
        let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        if (!reg.test(value)) {
          return callback(new Error(<string>this.$t('loginRegister.mailNotCorrect')))
        }
        callback()
      }
      return {
        username: [
          { required: true, message: this.$t('loginRegister.usernameEmptyError'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('loginRegister.mailEmptyError'), trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('loginRegister.passwordEmptyError'), trigger: 'blur' }
        ],
        password2: [
          { required: true, message: this.$t('loginRegister.passwordEmptyError'), trigger: 'blur' },
          { validator: checkConfirmPassword, trigger: 'blur' }
        ],
        industry: [
          { required: true, validator: checkIndustry, trigger: 'blur' }
        ],
        organization: [
          { required: true, message: this.$t('loginRegister.register.organizationEmptyError'), trigger: 'blur' },
        ],
        career: [
          { required: true, message: this.$t('loginRegister.register.careerEmptyError'), trigger: 'blur' },
        ],
        captcha: [
          { validator: checkCaptcha, trigger: 'blur' }
        ]
      }
    }

    /**
     * 检查验证码是否正确
     * @param value 输入的验证码
     */
    private checkCaptcha (value: string) {
      return checkCaptcha(null, value, { showSuccessMsg: false, showErrorMsg: false }).start().then(() => {
        return true
      }).catch(() => {
        return false
      })
    }

    /**
     * 注册
     */
    private registerHandler () {
      this.submitForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const registerResult = await register(null, {
              username: this.form.username,
              password: this.form.password,
              email: this.form.email,
              industry: this.selectOtherIndustry ? this.form.industryInput : this.form.industry,
              organization: this.form.organization,
              region: this.form.region,
              career: this.form.career,
              captcha: this.form.captcha
            }).start()
            this.$emit('registerSuccess')
          } catch (e) {
            console.log(e)
          }
          this.loading = false
        } else {
          return false
        }
      })
    }
}
